import { Reveal } from "./Reveal";

export const SectionHead = ({ number, eyebrow, title, description, align = "left", testId }) => (
  <Reveal className={`mb-12 sm:mb-16 ${align === "center" ? "text-center" : ""}`}>
    <div className={`flex items-center gap-4 ${align === "center" ? "justify-center" : ""}`}>
      {number && (
        <span className="font-mono text-xs font-bold tracking-[0.3em] text-gold">{number}</span>
      )}
      <span className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-kred">
        {eyebrow}
      </span>
    </div>
    <h2
      data-testid={testId}
      className="mt-4 font-head text-2xl font-bold uppercase tracking-tight text-bone sm:text-3xl lg:text-4xl"
    >
      {title}
    </h2>
    {description && (
      <p className={`mt-5 max-w-2xl text-base leading-relaxed text-slate-400 ${align === "center" ? "mx-auto" : ""}`}>
        {description}
      </p>
    )}
    <div className={`gold-rule mt-8 w-24 ${align === "center" ? "mx-auto" : ""}`} />
  </Reveal>
);
